import { onDOMLoaded } from './util/misc.js'
import { tns } from 'tiny-slider'

let slider = '.carousel-block .js-slider'

onDOMLoaded(() => {
  carousel(slider)
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=carousel', function() {
    carousel(slider)
  })
}

function carousel(qSelector) {
  if (document.querySelector(qSelector)) {
    tns({
      container: slider,
      prevButton: '.carousel-block .slider-controls .prev',
      nextButton: '.carousel-block .slider-controls .next',
      nav: false,
      // autoplay: true,
      autoplayButtonOutput: false,
      lazyload: true,
      loop: false,
      mouseDrag: true,
      responsive: {
        0: {
          items: 2,
          gutter: 45,
          fixedWidth: 210,
        },
        768: {
          items: 3,
          gutter: 85,
          fixedWidth: 251,
        },
        1280: {
          items: 4,
          gutter: 114,
          fixedWidth: 280,
        },
        1750: {
          items: 5,
          gutter: 100,
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/block-carousel.js